const configs = {
  "rowSelection": false,
  fieldControl: false,
  "searchMode": "group",
  "columns": [
    {
      "title": "目标类型",
      "dataIndex": "categoryName",
      "width": 150
    },
    {
      "title": "门店",
      "dataIndex": "companyName",
      "width": 150
    },
    {
      "title": "部门",
      "dataIndex": "departmentName",
      "width": 150
    },
    {
      "title": "年月",
      "dataIndex": "yearMonth",
      "width": 120,
    },
    {
      "title": "战略目标（万）",
      "dataIndex": "strategyAmount",
      "width": 160,
      ellipsis: {
        showTitle: true,
        overlayStyle: {minWidth: '50px'}
      }
    },
    {
      "title": "理想目标（万）",
      "dataIndex": "idealAmount",
      "width": 160,
      ellipsis: {
        showTitle: true,
        overlayStyle: {minWidth: '50px'}
      }
    },
    {
      "title": "状态",
      "dataIndex": "statusName",
      "width": 100
    },
    {
      "title": "操作",
      "render": "actionTool",
      "width": 180,
      "fixed": "right"
    }
  ],
  "search": [
    {
      "name": "category",
      "label": "类型",
      "itemType": "select",
      "data": "category",
      "key": "priKey",
      "labelKey": "name",
      "events": ["onChange:onSelectChange"]
    },
    {
      "name": "companyCode",
      "label": "门店",
      "itemType": "select",
      "key": "orgId",
      "labelKey": "companyName",
      "data": "company",
      "events": ["onChange:onSelectChange"]
    },
    {
      "name": "departmentCode",
      "label": "部门",
      "itemType": "select",
      "key": "orgId",
      "labelKey": "departmentName",
      "data": "dept"
    },
    {
      "name": "yearMonth",
      "label": "年月",
      "dataIndex": "yearMonth",
      "itemType": "custom",
      "render": "selectRender",
      "allowClear": true
    },
    {
      "name": "status",
      "label": "状态",
      "itemType": "select",
      "data": "productType"
    }
  ],
  "footer": [
    {
      "label": "新增",
      "type": "primary",
      "events": ["onClick:onAdd"]
    }
  ]
}
export { configs } 